import { DepartmentOption } from 'src/app/pages/extension-register/models/extension-option.interface';
import { createEagerSelectActions } from '../../select/eager-select/eager-select-actions';

export const departmentOptionActions = createEagerSelectActions<DepartmentOption>('[Department Options]');
